/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull frontend-spa'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 3
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/keenetic-rmm/Develop/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/keenetic-rmm/Develop/implementation/frontend-spa)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'develop';

export const ApiKey: Record<Environment, string> = {
  develop: '98ed4429cd43ac1f9e686f02c70aaf95',
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '3',
    branch: 'main',
    source: 'frontend-spa',
    versionId: 'd3429c75-8b5d-421a-a5d0-7468251387c2',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
};

export interface LoadOptionsBase {
  disabled?: boolean;
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment;
  client?: { configuration?: BrowserOptions };
};
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions };
};
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient };
};

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance;

export interface DashboardClickProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Nodes Distribution, Traffic Distribution Clients, Traffic Distribution Connection Type, Clients Distribution Segments, Clients Distribution Connection Type, Status, Main Connection, Reserved Connection, Actions |
   */
  dashboard_element:
    | 'Nodes Distribution'
    | 'Traffic Distribution Clients'
    | 'Traffic Distribution Connection Type'
    | 'Clients Distribution Segments'
    | 'Clients Distribution Connection Type'
    | 'Status'
    | 'Main Connection'
    | 'Reserved Connection'
    | 'Actions';
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Legend, Slice, Button, Dropdown |
   */
  dashboard_element_item: 'Legend' | 'Slice' | 'Button' | 'Dropdown';
}

export interface RoleChangedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | administrator, manager, owner, viewer |
   */
  new_role: 'administrator' | 'manager' | 'owner' | 'viewer';
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | administrator, manager, owner, viewer |
   */
  old_role: 'administrator' | 'manager' | 'owner' | 'viewer';
  team_id: string;
}

export interface SiteAutoSharingChangedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | on, off |
   */
  access_state: 'on' | 'off';
  team_id: string;
}

export interface SiteSharingChangedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  site_id_array: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | added, removed |
   */
  site_state: 'added' | 'removed';
  team_id: string;
}

export interface TeamCreatedProperties {
  team_id: string;
}

export interface TeamMemberInvitedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | email, link |
   */
  invite_method: 'email' | 'link';
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | administrator, manager, owner, viewer |
   */
  role_assigned: 'administrator' | 'manager' | 'owner' | 'viewer';
  team_id: string;
}

export interface TeamMemberJoinedTeamProperties {
  team_id: string;
}

export interface TeamMemberRemovedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  removed_user_id_array: string[];
  team_id: string;
}

export interface TeamRemovedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  team_id_array: string[];
}

export class DashboardClick implements BaseEvent {
  event_type = 'Dashboard Click';

  constructor(public event_properties: DashboardClickProperties) {
    this.event_properties = event_properties;
  }
}

export class RoleChanged implements BaseEvent {
  event_type = 'Role Changed';

  constructor(public event_properties: RoleChangedProperties) {
    this.event_properties = event_properties;
  }
}

export class SiteAutoSharingChanged implements BaseEvent {
  event_type = 'Site Auto-Sharing Changed';

  constructor(public event_properties: SiteAutoSharingChangedProperties) {
    this.event_properties = event_properties;
  }
}

export class SiteSharingChanged implements BaseEvent {
  event_type = 'Site Sharing Changed';

  constructor(public event_properties: SiteSharingChangedProperties) {
    this.event_properties = event_properties;
  }
}

export class TeamCreated implements BaseEvent {
  event_type = 'Team Created';

  constructor(public event_properties: TeamCreatedProperties) {
    this.event_properties = event_properties;
  }
}

export class TeamMemberInvited implements BaseEvent {
  event_type = 'Team Member Invited';

  constructor(public event_properties: TeamMemberInvitedProperties) {
    this.event_properties = event_properties;
  }
}

export class TeamMemberJoinedTeam implements BaseEvent {
  event_type = 'Team Member Joined Team';

  constructor(public event_properties: TeamMemberJoinedTeamProperties) {
    this.event_properties = event_properties;
  }
}

export class TeamMemberRemoved implements BaseEvent {
  event_type = 'Team Member Removed';

  constructor(public event_properties: TeamMemberRemovedProperties) {
    this.event_properties = event_properties;
  }
}

export class TeamRemoved implements BaseEvent {
  event_type = 'Team Removed';

  constructor(public event_properties: TeamRemovedProperties) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Dashboard Click
   *
   * [View in Tracking Plan](https://data.amplitude.com/keenetic-rmm/Develop/events/main/latest/Dashboard%20Click)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. dashboard_element)
   * @param options Amplitude event options.
   */
  dashboardClick(
    properties: DashboardClickProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    return this.track(new DashboardClick(properties), options);
  }

  /**
   * Role Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/keenetic-rmm/Develop/events/main/latest/Role%20Changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. new_role)
   * @param options Amplitude event options.
   */
  roleChanged(
    properties: RoleChangedProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    return this.track(new RoleChanged(properties), options);
  }

  /**
   * Site Auto-Sharing Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/keenetic-rmm/Develop/events/main/latest/Site%20Auto-Sharing%20Changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. access_state)
   * @param options Amplitude event options.
   */
  siteAutoSharingChanged(
    properties: SiteAutoSharingChangedProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    return this.track(new SiteAutoSharingChanged(properties), options);
  }

  /**
   * Site Sharing Changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/keenetic-rmm/Develop/events/main/latest/Site%20Sharing%20Changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. site_id_array)
   * @param options Amplitude event options.
   */
  siteSharingChanged(
    properties: SiteSharingChangedProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    return this.track(new SiteSharingChanged(properties), options);
  }

  /**
   * Team Created
   *
   * [View in Tracking Plan](https://data.amplitude.com/keenetic-rmm/Develop/events/main/latest/Team%20Created)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. team_id)
   * @param options Amplitude event options.
   */
  teamCreated(
    properties: TeamCreatedProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    return this.track(new TeamCreated(properties), options);
  }

  /**
   * Team Member Invited
   *
   * [View in Tracking Plan](https://data.amplitude.com/keenetic-rmm/Develop/events/main/latest/Team%20Member%20Invited)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. invite_method)
   * @param options Amplitude event options.
   */
  teamMemberInvited(
    properties: TeamMemberInvitedProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    return this.track(new TeamMemberInvited(properties), options);
  }

  /**
   * Team Member Joined Team
   *
   * [View in Tracking Plan](https://data.amplitude.com/keenetic-rmm/Develop/events/main/latest/Team%20Member%20Joined%20Team)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. team_id)
   * @param options Amplitude event options.
   */
  teamMemberJoinedTeam(
    properties: TeamMemberJoinedTeamProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    return this.track(new TeamMemberJoinedTeam(properties), options);
  }

  /**
   * Team Member Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/keenetic-rmm/Develop/events/main/latest/Team%20Member%20Removed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. removed_user_id_array)
   * @param options Amplitude event options.
   */
  teamMemberRemoved(
    properties: TeamMemberRemovedProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    return this.track(new TeamMemberRemoved(properties), options);
  }

  /**
   * Team Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/keenetic-rmm/Develop/events/main/latest/Team%20Removed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. team_id_array)
   * @param options Amplitude event options.
   */
  teamRemoved(
    properties: TeamRemovedProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    return this.track(new TeamRemoved(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
